import React, { useMemo } from 'react';
import {
  useTable,
  useSortBy,
  useFilters,
  useGlobalFilter,
  usePagination,
} from 'react-table';

import BaseTable from '../../../shared/BaseTable';
import Loading from '../../../shared/Loading';
import { TableColumns } from './TableColumns';

export default function TransactionsTable({ transactions, err }) {
  const data = useMemo(() => transactions, [transactions]);
  const columns = useMemo(() => TableColumns, []);
  const sortTypes = React.useMemo(
    () => ({
      alphanumericFalsyLast(rowA, rowB, columnId) {
        const a = Number(rowA.values[columnId]);
        const b = Number(rowB.values[columnId]);

        return Number(a) - Number(b);
      },
    }),
    [],
  );
  const instance = useTable(
    {
      columns,
      data,
      initialState: {
        pageSize: 5,
        sortBy: [{ id: 'value_date', desc: true }],
      },
      sortTypes
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
  );

  if (!transactions) return <Loading className="w-14 h-14" />;

  return (
    <div
      role={TransactionsTable.role}
      className="col-span-full rounded-lg border border-black border-opacity-5 py-1 overflow-x-scroll mt-6"
    >
      <div className="text-xl font-avenir-black text-navy-blue px-6 py-3 border-b">
        Transactions
      </div>
      <BaseTable
        tableInstance={instance}
        noDataFoundWarning={err ? 'Error: Unable to retrieve order transactions.' : "No transactions found."}
        tableClass='min-h-[21rem]'
        addRows={6}
        fillTable={true}
      />
    </div>
  );
}

TransactionsTable.role = 'transactions-table-component';
